import { useEffect, useRef } from "react";

/**
 * Textarea that auto-grows to fit its content and remains user-resizable vertically.
 * Removes scroll-inside-textarea frustration entirely while keeping a sane min-height.
 */
export default function AutoTextarea({
  value,
  onChange,
  minRows = 3,
  maxHeight = 800,
  className = "",
  ...rest
}) {
  const ref = useRef(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const next = Math.min(el.scrollHeight, maxHeight);
    el.style.height = next + "px";
  };

  useEffect(() => {
    resize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  // Recompute on mount in case content was prefilled before paint
  useEffect(() => {
    resize();
    const onWinResize = () => resize();
    window.addEventListener("resize", onWinResize);
    return () => window.removeEventListener("resize", onWinResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <textarea
      ref={ref}
      value={value ?? ""}
      onChange={(e) => {
        onChange?.(e);
        resize();
      }}
      rows={minRows}
      className={`resize-y overflow-hidden ${className}`}
      style={{ minHeight: `${minRows * 1.6}em` }}
      {...rest}
    />
  );
}
